import React from 'react';
import Box from '@mui/material/Box';

export default function FullSizeBanner({ children }) {
    return (
        <Box sx={{ height: {md: '820px', xs: 'auto'}, position: 'relative', minHeight: {md: 'unset', xs: '500px' } }}>
            {children}
        </Box>
    )
}